import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setAuthenticated } from '../../store/slices/userSlice';
import { setLanguage } from '../../store/slices/configSlice';
import { useTranslation } from 'react-i18next';


const LoadDataFromStorage = () => {
    const dispatch = useDispatch();
    dispatch(setLanguage(window.localStorage.getItem("dl-lang") ? window.localStorage.getItem("dl-lang") : "es"));

    return null;
}

export default LoadDataFromStorage;